import { connect } from "react-redux";
import { Navigate, useLocation } from "react-router";
import { routes } from "./routes";

const PublicRoute = ({ children, metaProps, auth }) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const from = searchParams.get('from') || routes.home.path;

  if (metaProps.isAuth && auth.user) {
    return (
      <Navigate to={from} />
    )
  }
  return <div>{children}</div>;
};

export default connect(({ auth }) => ({ auth }))(PublicRoute)
